export default "__VITE_ASSET__DFt_IwKn__"